import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 381892 210888"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:5479.32}.fil0{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970273093312">
        <path
          d="M294733 2740H172073l83631 102704-83631 102705h122660l83625-102705z"
          className="fill stroke1"
          style={{
            strokeWidth: 5479.32,
          }}
        />
        <path
          d="M128529 2740H88497l83630 102704-83630 102705h40032l83636-102705z"
                    className="fill stroke1"
          style={{
            strokeWidth: 5479.32,
          }}

        />
        <path
          d="M45802 2740H5764l83631 102704L5764 208149h40038l83631-102705z"
                    className="fill stroke1"
          style={{
            strokeWidth: 5479.32,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
